import { Component, OnInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupsService } from 'src/app/services/lookups/lookups.service';
import { ResponseResult } from 'src/app/models-classes/common.model';
import { environment } from 'src/environments/environment';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { SettingsService } from 'src/app/services/settings.service';
import { CustomValidators } from 'src/app/shared/validators/custom-validators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
declare var google: any;
declare var $: any;

@Component({
  selector: 'app-single-order',
  templateUrl: './single-order.component.html',
  styleUrls: ['./single-order.component.scss']
})
export class SingleOrderComponent implements OnInit {
  @ViewChild('senderMapContainer') senderMapContainer: ElementRef;
  @ViewChild('receiverMapContainer') receiverMapContainer: ElementRef;
  @ViewChild('senderSearchInput') senderSearchInput: ElementRef;
  @ViewChild('receiverSearchInput') receiverSearchInput: ElementRef;
  paymentMethodIcons = {
    Cach: {
      iconClass: '/assets/img/cards/cash.png',
      numericValue: 0,
      text: 'Cach',
    },
    // POS: {
    //   iconClass: '/assets/img/cards/pos.png',
    //   numericValue: 1,
    //   text: 'POS',
    // },
    // ApplePay: {
    //   iconClass: '/assets/img/cards/apple-pay.png',
    //   numericValue: 2,
    //   text: 'Apple',
    // },
    Knet: {
      iconClass: '/assets/img/cards/knet.png',
      numericValue: 3,
      text: 'Knet',
    },
    Card: {
      iconClass: '/assets/img/cards/credit-card.png',
      numericValue: 4,
      text: 'Card',
    },
    WalletPay: {
      iconClass: '/assets/img/cards/wallet.png',
      numericValue: 5,
      text: 'Wallet',
    },
  };
  toggleModal(id, text) {
    this.paymentNumber = id;
    this.orderForm.patchValue({ paymentTypeId: id });
    this.paymentMethodText = 'Your payment method is ' + text;
  }
  getPaymentMethodKeys() {
    return Object.keys(this.paymentMethodIcons);
  }
  isApple = false;
  paymentNumber = 0;
  orderForm: FormGroup;
  serviceType: 'send' | 'receive' = 'send';
  vehicleSizes: any[] = [];
  selectedImages: string[] = [];
  isSubmitting = false;
  map: any;
  marker: any;
  geocoder: any;
  currentLocationTarget: 'sender' | 'receiver';
  searchBox: any;
  isMapVisible = false;
  deliveryPrice: number | null = null;
  
  // Store coordinates for sender and receiver
  senderCoordinates: { lat: number; lng: number } | null = null;
  receiverCoordinates: { lat: number; lng: number } | null = null;
  paymentMethodText = 'Your payment method is Cach';
  
  // Properties for navbar
  address = localStorage.getItem('address');
  countryId = +localStorage.getItem('countryId');
  current_lang = localStorage.getItem('current_lang') || 'en';

  constructor(
    private fb: FormBuilder,
    private lookupsService: LookupsService,
    private ngZone: NgZone,
    private customerService: CustomerService,
    public settingService: SettingsService,
    private _toast: ToastrService,
    private translateService: TranslateService,
    private router: Router
  ) {
    this.initForm();
  }
  closeModal() {
    if (this.paymentMethodText == 'Select your payment method')
      this.paymentMethodText = 'Your payment method is Cach';
    $('#paymentMethodsModal').modal('hide');
  }
  ngOnInit() {
    this.loadVehicleSizes();
    this.loadAdvancedMarkersLibrary();
  }

  private initForm() {
    /*
    {
  "deliveryServiceType": 1,
  "paymentTypeId": 0,
  "senderName": "string",
  "senderPhone": "string",
  "senderAddress": "string",
  "senderLatLng": "string",
  "senderCity": "string",
  "senderRegion": "string",
  "senderStreet": "string",
  "senderBuildingNo": "string",
  "senderApartmentNo": "string",
  "receiverName": "string",
  "receiverPhone": "string",
  "receiverAddress": "string",
  "receiverLatLng": "string",
  "receiverCity": "string",
  "receiverRegion": "string",
  "receiverStreet": "string",
  "receiverBuildingNo": "string",
  "receiverApartmentNo": "string",
  "packageType": "string",
  "deliveryCarSizeId": 0,
  "packageDescription": "string",
  "packageImages": [
    "string"
  ],
  "price": 0,
  "distance": 0,
  "notes": "string"
}
    */
    this.orderForm = this.fb.group({
      deliveryServiceType: [1],
      senderName: ['', [Validators.required]],
      paymentTypeId: [0],
      senderPhone: ['', [Validators.required, CustomValidators.phoneValidator]],
      senderAddress: ['', [Validators.required]],
      senderCity: ['', [Validators.required]],
      senderRegion: ['', [Validators.required]],
      senderStreet: [''],
      senderBuildingNo: [''],
      senderApartmentNo: [''],
      senderLatLng: ['', [Validators.required]],
      receiverLatLng: ['', [Validators.required]],
      receiverName: ['', [Validators.required]],
      receiverPhone: ['', [Validators.required, CustomValidators.phoneValidator]],
      receiverAddress: ['', [Validators.required]],
      receiverCity: ['', [Validators.required]],
      receiverRegion: ['', [Validators.required]],
      receiverStreet: [''],
      receiverBuildingNo: [''],
      receiverApartmentNo: [''],
      packageType: ['', [Validators.required]],
      deliveryCarSizeId: ['', [Validators.required]],
      packageDescription: [''],
      packageWeight: [''],
      notes: [''],
      packageImages: [[]],
      price: [0],
      distance: [0],
    });
  }

  loadVehicleSizes() {
    this.lookupsService.getDeliveryCarSizes().subscribe(
      (response: ResponseResult) => {
        if (response.isSuccess) {
          this.vehicleSizes = response.data;
        }
      },
      error => {
        console.error('Error loading vehicle sizes:', error);
      }
    );
  }

  setServiceType(type: 'send' | 'receive') {
    this.serviceType = type;
    this.orderForm.patchValue({ deliveryServiceType: type === 'send' ? 1 : 2 });
  }

  createBatchOrders() {
    // Implement batch orders functionality
    console.log('Create batch orders clicked');
  }

  selectVehicleSize(sizeId: number) {
    this.orderForm.patchValue({ 
      // vehicleSize: sizeId,
      deliveryCarSizeId: sizeId // Make sure this matches your API expectation
    });
    this.calculateDeliveryPrice();
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files) {
      Array.from(files).forEach((file: any) => {
        if (file.type.startsWith('image/')) {
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.selectedImages.push(e.target.result);
            const currentImages = this.orderForm.get('packageImages').value;
            this.orderForm.patchValue({
              packageImages: [...currentImages, e.target.result]
            });
          };
          reader.readAsDataURL(file);
        }
      });
    }
  }

  calculateDeliveryPrice() {
    const formValue = this.orderForm.value;
    console.log(formValue);
    if (formValue.senderLatLng && formValue.receiverLatLng && formValue.deliveryCarSizeId) {
      this.customerService.calculateSendReceivePrice(
        formValue.senderLatLng, 
        formValue.receiverLatLng, 
        formValue.deliveryCarSizeId
      ).subscribe((response: ResponseResult) => {
        if (response.isSuccess) {
          this.deliveryPrice = response.data.price;
          this.orderForm.patchValue({
            price: response.data.price,
            distance: response.data.distance
          });
        }
      });
    }
  }

  removeImage(index: number) {
    this.selectedImages.splice(index, 1);
    const currentImages = this.orderForm.get('packageImages').value;
    currentImages.splice(index, 1);
    this.orderForm.patchValue({ packageImages: currentImages });
  }
  countryCode = localStorage.getItem('countryCode');
  private loadAdvancedMarkersLibrary() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMaps.apiKey}&libraries=places,marker&country=${this.countryCode}`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.geocoder = new google.maps.Geocoder();
    };
    document.head.appendChild(script);
  }

  openMap(target: 'sender' | 'receiver') {
    this.currentLocationTarget = target;
    this.isMapVisible = true;
    
    setTimeout(() => {
      const mapContainer = target === 'sender' ? this.senderMapContainer : this.receiverMapContainer;
      
      // Always reinitialize the map when opening
      const mapOptions = {
        center: { lat: 29.3759, lng: 47.9774 }, // Kuwait City coordinates
        zoom: 12,
        mapId: environment.googleMaps.mapId
      };
      
      this.map = new google.maps.Map(mapContainer.nativeElement, mapOptions);
      
      // Create the marker
      if (this.marker) {
        this.marker.setMap(null);
      }
      
      this.marker = new google.maps.marker.AdvancedMarkerElement({
        map: this.map,
        position: mapOptions.center,
        draggable: true,
        title: 'Drag me!'
      });

      // Add click event listener to map
      this.map.addListener('click', (event: any) => {
        this.updateMarkerPosition(event.latLng);
      });

      // Add dragend event listener to marker
      this.marker.addListener('dragend', () => {
        const position = this.marker.position;
        this.updateMarkerPosition(position);
      });

      // Initialize search box
      this.initializeSearchBox(target);
    });
  }

  private initializeSearchBox(target: 'sender' | 'receiver') {
    const searchInput = target === 'sender' ? this.senderSearchInput : this.receiverSearchInput;
    
    if (searchInput && google.maps.places) {
      this.searchBox = new google.maps.places.SearchBox(searchInput.nativeElement);
      
      // Bias SearchBox results towards current map's viewport
      this.map.addListener('bounds_changed', () => {
        this.searchBox.setBounds(this.map.getBounds());
      });

      // Listen for the event fired when the user selects a prediction
      this.searchBox.addListener('places_changed', () => {
        const places = this.searchBox.getPlaces();
        if (places.length === 0) return;

        const place = places[0];
        if (!place.geometry || !place.geometry.location) return;

        // Update map and marker
        this.map.setCenter(place.geometry.location);
        this.updateMarkerPosition(place.geometry.location);
      });
    }
  }

  searchLocation(target: 'sender' | 'receiver') {
    const searchInput = target === 'sender' ? this.senderSearchInput : this.receiverSearchInput;
    const searchValue = searchInput.nativeElement.value;
    
    if (!searchValue.trim()) return;

    this.geocoder.geocode({ address: searchValue }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.ngZone.run(() => {
          const location = results[0].geometry.location;
          const addressComponents = results[0].address_components;
          const formattedAddress = results[0].formatted_address;
          
          // Create an object to store address components
          const addressParts: any = {
            street_number: '',
            route: '',
            locality: '',
            sublocality_level_1: '',
            administrative_area_level_1: '',
            country: ''
          };

          // Extract address components
          addressComponents.forEach((component: any) => {
            const type = component.types[0];
            if (addressParts.hasOwnProperty(type)) {
              addressParts[type] = component.long_name;
            }
          });

          // Update map and marker
          this.map.setCenter(location);
          if (this.marker) {
            this.marker.position = location;
          }

          // Update form controls based on target
          if (target === 'sender') {
            this.orderForm.patchValue({
              senderAddress: formattedAddress,
              senderCity: addressParts.locality || '',
              senderRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
              senderStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || '')
            });
            this.senderCoordinates = {
              lat: location.lat(),
              lng: location.lng()
            };
          } else {
            this.orderForm.patchValue({
              receiverAddress: formattedAddress,
              receiverCity: addressParts.locality || '',
              receiverRegion: addressParts.sublocality_level_1 || addressParts.administrative_area_level_1 || '',
              receiverStreet: (addressParts.street_number ? addressParts.street_number + ' ' : '') + (addressParts.route || '')
            });
            this.receiverCoordinates = {
              lat: location.lat(),
              lng: location.lng()
            };
          }
        });
      }
    });
  }

  closeMap() {
    this.isMapVisible = false;
    if (this.marker) {
      this.marker.setMap(null);
    }
    this.map = null;
  }

  // confirmLocation() {
  //   if (!this.marker || !this.map) return;

  //   const position = this.marker.position;
  //   this.geocoder.geocode({ location: position }, (results: any, status: any) => {
  //     if (status === 'OK' && results[0]) {
  //       this.ngZone.run(() => {
  //         const addressComponents = results[0].address_components;
  //         const formattedAddress = results[0].formatted_address;
  //         console.log(formattedAddress);
  //         console.log(addressComponents);
  //         // Create an object to store address components
  //         const addressParts: any = {
  //           street_number: '',
  //           route: '',
  //           locality: '',
  //           sublocality_level_1: '',
  //           administrative_area_level_1: '',
  //           country: ''
  //         };

  //         // Extract address components
  //         addressComponents.forEach((component: any) => {
  //           const type = component.types[0];
  //           if (addressParts.hasOwnProperty(type)) {
  //             addressParts[type] = component.long_name;
  //           }
  //         });

  //          // Compose values with fallback logic
  //       const street = [addressParts.street_number, addressParts.route].filter(Boolean).join(' ');
  //       const city = addressParts.locality || addressParts.sublocality_level_1 || addressParts.sublocality || '';
  //       const region = addressParts.administrative_area_level_1 || addressParts.administrative_area_level_2 || '';


  //         // Update form controls based on target
  //         if (this.currentLocationTarget === 'sender') {
  //           this.orderForm.patchValue({
  //             senderAddress: formattedAddress,
  //             senderCity: city,
  //             senderRegion: region,
  //             senderStreet: street
  //           });
  //           this.updateLocationLatLng('sender', {
  //             lat: position.lat,
  //             lng: position.lng
  //           });
  //         } else {
  //           this.orderForm.patchValue({
  //             receiverAddress: formattedAddress,
  //             receiverCity: city,
  //             receiverRegion: region,
  //             receiverStreet: street
  //           });
  //           this.updateLocationLatLng('receiver', {
  //             lat: position.lat,
  //             lng: position.lng
  //           });
  //         }

  //         this.closeMap();
  //       });
  //     }
  //   });
  // }
  confirmLocation() {
    if (!this.marker || !this.map) return;
  
    const position = this.marker.position;
    this.geocoder.geocode({ location: position }, (results: any, status: any) => {
      if (status === 'OK' && results[0]) {
        this.ngZone.run(() => {
          const addressComponents = results[0].address_components;
          const formattedAddress = results[0].formatted_address;
          console.log(formattedAddress);
          console.log(addressComponents);
          
          // Create an object to store address components
          const addressParts: any = {
            street_number: '',
            route: '',
            locality: '',
            sublocality_level_1: '',
            administrative_area_level_1: '',
            country: '',
            postal_town: '' // Add this as some locations use postal_town for city
          };
  
          // Extract address components
          addressComponents.forEach((component: any) => {
            component.types.forEach((type: string) => {
              if (addressParts.hasOwnProperty(type)) {
                addressParts[type] = component.long_name;
              }
            });
          });
  
          // Compose values with fallback logic
          const street = [addressParts.street_number, addressParts.route].filter(Boolean).join(' ');
          const city = addressParts.locality || 
                      addressParts.postal_town || 
                      addressParts.sublocality_level_1 || 
                      addressParts.sublocality || 
                      '';
          const region = addressParts.administrative_area_level_1 || 
                        addressParts.administrative_area_level_2 || 
                        '';
  
          // Update form controls based on target
          if (this.currentLocationTarget === 'sender') {
            this.orderForm.patchValue({
              senderAddress: formattedAddress,
              senderCity: city,
              senderRegion: region,
              senderStreet: street
            });
            this.updateLocationLatLng('sender', {
              lat: position.lat,
              lng: position.lng
            });
          } else {
            this.orderForm.patchValue({
              receiverAddress: formattedAddress,
              receiverCity: city,
              receiverRegion: region,
              receiverStreet: street
            });
            this.updateLocationLatLng('receiver', {
              lat: position.lat,
              lng: position.lng
            });
          }
  
          this.closeMap();
        });
      }
    });
  }

  private updateMarkerPosition(position: any) {
    if (this.marker) {
      this.marker.position = position;
    }
  }

  private updateLocationLatLng(target: 'sender' | 'receiver', coordinates: { lat: number; lng: number }) {
    const latLng = `${coordinates.lat},${coordinates.lng}`;
    if (target === 'sender') {
      this.orderForm.patchValue({ senderLatLng: latLng });
      this.senderCoordinates = coordinates;
    } else {
      this.orderForm.patchValue({ receiverLatLng: latLng });
      this.receiverCoordinates = coordinates;
    }
    this.calculateDeliveryPrice();
  }

  onSubmit() {
    if (this.orderForm.valid) {
      this.isSubmitting = true;
      
      // Prepare form data
      const formData = this.orderForm.value;
      console.log(this.orderForm);
      console.log(formData);
      // Here you would typically send the data to your backend
      console.log('Form submitted:', formData);
      this.customerService.createOrder(formData).subscribe((response: ResponseResult) => {
        if (response.isSuccess) {
          // this.router.navigate(['/order-success']);
          //show success message and reset form
          this.orderForm.reset();
          this.paymentMethodText = 'Your payment method is Cach';
          this.paymentNumber = 0;
          this.orderForm.patchValue({ paymentTypeId: 0,deliveryServiceType:1,senderPhone:'',receiverPhone:'' });
          this.closeModal();
          this.isSubmitting = false;
          this._toast.success(this.translateService.instant('OrderCreatedSuccessfully'));
          this.router.navigate(['/my-orders']);
        }
        else {
          const translatedErrors = response.errors.map((error) =>
            this.translateService.instant(error)
          );
          const errorMessage = translatedErrors.join('\n');
          this._toast.error(errorMessage);
        }
      });
      this.isSubmitting = false;
    } else {
      Object.keys(this.orderForm.controls).forEach(key => {
        const control = this.orderForm.get(key);
        if (control.invalid) {
          control.markAsTouched();
        }
      });
    }
  }

  // Method for navbar
  getCountryId(id: string) {
    localStorage.setItem('countryId', id);
    this.countryId = +id;
  }

  // Add validation messages method
  getErrorMessage(controlName: string): string {
    const control = this.orderForm.get(controlName);
    if (control && control.errors && control.touched) {
      if (control.errors['required']) {
        return controlName.replace(/([A-Z])/g, ' $1').toLowerCase() + '.required';
      }
      if (control.errors['min']) {
        return controlName.replace(/([A-Z])/g, ' $1').toLowerCase() + '.min';
      }
    }
    return '';
  }

  isFieldInvalid(controlName: string): boolean {
    const control = this.orderForm.get(controlName);
    return control ? (control.invalid && (control.dirty || control.touched)) : false;
  }
}
